import React from 'react';
import { View, StyleSheet, Animated } from 'react-native';

interface NewsCardSkeletonProps {
  width?: number | string;
}

const NewsCardSkeleton: React.FC<NewsCardSkeletonProps> = ({ width }) => {
  const opacity = React.useRef(new Animated.Value(0.3)).current;

  React.useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 800,
          useNativeDriver: true,
        }),
      ])
    );
    animation.start();
    return () => animation.stop();
  }, [opacity]);

  const containerStyle: any = [styles.container];
  if (width !== undefined) containerStyle.push({ width });

  return (
    <View style={containerStyle}>
      <View style={styles.header}>
        <Animated.View style={[styles.title, { opacity }]} />
        <Animated.View style={[styles.date, { opacity }]} />
      </View>
      <Animated.View style={[styles.descriptionLine1, { opacity }]} />
      <Animated.View style={[styles.descriptionLine2, { opacity }]} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderColor: '#E2E8F0',
    borderWidth: 1,
    padding: 16,
    minHeight: 120,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  title: {
    flex: 1,
    height: 18,
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
    marginRight: 12,
  },
  date: {
    width: 60,
    height: 14,
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
  },
  descriptionLine1: {
    width: '100%',
    height: 14,
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
    marginBottom: 6,
  },
  descriptionLine2: {
    width: '80%',
    height: 14,
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
  },
});

export default NewsCardSkeleton;
